import React from "react";
import {OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import Input from "../../components/input";
import { NpaInquiryList } from "../../components/TableHeadings";
import ExportBtnWithIcon from "../../components/exportBtnWithIcon";
import NoData from "../../components/no-data";
import { getUserInitial } from "../../components/common";
import moment from "moment";
import { MepEyeIcon} from "../../assets/icons";
import StatusChip from "../../components/statusChip";

const InquiryList = ({
  data,
  searchTerm,
  setSearchTerm,
  setCurrentPage,
  handleOpenViewModal,
  handleExportInquiry,
}) => {
  
  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between gap-4">
        <Input
          type="search"
          value={searchTerm}
          placeholder="Search Inquiry"
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          className="shadow-none base-search"
        />

        <div className="action-buttons-container">
          <ExportBtnWithIcon title="Export" onClick={handleExportInquiry} />
        </div>
      </div>

      <Table responsive className="common-table">
        <thead>
          <tr>
            {NpaInquiryList?.map((column, index) => (
              <th key={index}>{column.label}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data?.length === 0 ? (
            <NoData />
          ) : (
            data?.map((item, i) => (
              <tr key={item?.id}>
                <td>{item?.property  ? `# ${item?.property?.property_number_id}`  : "-"}</td>
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div className="profile-icon">{item?.user_name ? getUserInitial(item?.user_name) : "-"}</div>
                    <div className="ms-1"><p className="fw-medium text-capitalize">{item?.user_name ? item?.user_name : "-"}</p></div>
                  </div>
                </td>
                <td className="text-start">{item?.phone_number ? item?.phone_number : "-"}</td>
                <td>{item?.email ? item?.email : "-"}</td>
                <td>{item?.property ?  <StatusChip bg={"chip-green"} pill title={item?.property?.possessionType?.name} className="text-capitalize"/> : ""}</td>
                <td>{item?.property ?  <StatusChip bg={"chip-green"} pill title={item?.property?.propertyType?.name} className="text-capitalize"/> : ""} </td>
                <td className="text-start">
                  <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                    <span>{item?.createdAt ? moment(item.createdAt).format("DD MMM YYYY") : ""} </span>
                    <span>{item?.createdAt ? moment(item.createdAt).format("hh:mm A") : ""}</span>
                  </div>
                </td>
                <td onClick={(e) => e.stopPropagation()} className="cursor-pointer">
                  <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-top`}>View</Tooltip>}>
                    <span onClick={() => handleOpenViewModal(item)}>
                      <MepEyeIcon width={20} height={20} color="#6D6B77" strokeWidth="4"/>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </>
  );
};

export default InquiryList;
